import type { ReactNode } from 'react'
import styles from './Table.module.css'

type Row = {
    id: number
    col: ReactNode    
}[]

type Props = {
    headers: Row
    body: Row[] 
    align?: [
        id: number,
        align: 'center' | 'left'
    ][]
}

export default function Table({headers, body, align} :Props) {    
    let alignMap = new Map(headers.map((header) => [header.id, "center"]))    
    alignMap = new Map([...alignMap, ...align ?? []])

    return (
    <div className={styles.wrapper}>
        <table className={styles.table}>
            <thead>
                <tr className={styles.tr}>
                    {
                        headers.map((header) => (
                            <th 
                                key={`thead-th-${header.id}`}                                
                                className={alignMap.get(header.id) === 'center' ? styles.center : styles.left}
                            >
                                {header.col}
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    body.map((row, index) => (
                        <tr key={`tbody-tr-${index}`} className={`${styles.tr}  ${index % 2 !== 0 ? styles.gray : ""}`}>
                            {
                                row.map((col) => (
                                    <td 
                                        key={`tbody-td-${col.id}`}
                                        className={`${alignMap.get(col.id) === 'center' ? styles.center : styles.left}`}
                                    >
                                        {col.col}
                                    </td>
                                ))
                            }
                        </tr>
                    ))
                }
            </tbody>
        </table>
    </div>
  )
}
